import moment from 'moment'
import { createAction } from 'redux-api-middleware'
import type { RootState } from '../../reducers'
import { HUBBLE_API_TOKEN } from '../../store/middleware/APIUrl'
import type { Variant } from '../../types'
import ActionTypes from './actionTypes'
import { ArrayUtils, ObjectUtils } from '../../utils'

type VariantUpdateRequest = {
    type: typeof ActionTypes.VARIANT_UPDATE_REQUEST;
    payload: never;
}

type VariantUpdateFailure = {
    type: typeof ActionTypes.VARIANT_UPDATE_FAILURE;
    payload: Error;
}

type VariantUpdateSuccess = {
    type: typeof ActionTypes.VARIANT_UPDATE_SUCCESS;
    payload: Variant;
}

const UpdateVariantFields = [
    'class',
    'priority',
    'brand',
    'start_date',
    'end_date',
    'skus',
    'exceptions',
] as const

const serializeVariantExceptions = (v: Variant['exceptions']) => {
    const regions = Array.isArray(v?.regions) ? ArrayUtils.cleanStringArray(v.regions) : ''
    const skus = Array.isArray(v?.skus) ? ArrayUtils.cleanStringArray(v.skus) : ''
    const stores = Array.isArray(v?.stores) ? ArrayUtils.cleanStringArray(v.stores) : ''
    const uids = Array.isArray(v?.uids) ? ArrayUtils.cleanStringArray(v.uids) : ''
    const dates = Array.isArray(v?.dates)
        ? v.dates.map(d => moment(d as unknown as Date).format('YYYY-MM-DD')).join(',')
        : ''
    const less_than = typeof v?.price?.less_than === 'number' ? v.price.less_than : undefined
    const greater_than = typeof v?.price?.greater_than === 'number' ? v.price.greater_than : undefined

    return {
        ...(regions ? { regions } : {}),
        ...(skus ? { skus } : {}),
        ...(stores ? { stores } : {}),
        ...(uids ? { uids } : {}),
        ...(dates ? { dates } : {}),
        ...((less_than !== undefined || greater_than !== undefined)
            ? {
                price: {
                    ...(less_than !== undefined ? { less_than } : {}),
                    ...(greater_than !== undefined ? { greater_than } : {}),
                },
            }
            : {}),
    }
}

function updateVariant(variant: Variant) {
    const body = ObjectUtils.copy(variant, UpdateVariantFields, {
        start_date: (v: Date) => moment(v).format('YYYY-MM-DD'),
        end_date: (v: Date) => moment(v).format('YYYY-MM-DD'),
        skus: (v: unknown) => ArrayUtils.cleanStringArray(v),
        exceptions: serializeVariantExceptions,
    })


    return createAction<RootState, Variant, never>({
        endpoint: `${HUBBLE_API_TOKEN}/ticket-variants/${variant.id}`,
        method: 'PUT',
        body: JSON.stringify(body),
        types: [
            ActionTypes.VARIANT_UPDATE_REQUEST,
            ActionTypes.VARIANT_UPDATE_SUCCESS,
            ActionTypes.VARIANT_UPDATE_FAILURE,
        ],
    })
}

export type VariantUpdateAction = VariantUpdateRequest
    | VariantUpdateFailure
    | VariantUpdateSuccess

export default updateVariant
